// Author Lin
// Date 2021-11-06 10:05:06

import * as model from "@/model/mintalMes/mst/MintalMesMstGeneratorSetModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesMstGeneratorSet(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_MST_URL,
    })
    .buildStore()
